'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'pen-clip';
var width = 512;
var height = 512;
var aliases = ["pen-alt"];
var unicode = 'f305';
var svgPathData = 'M493.3 56.25l-37.5-37.5C443.3 6.253 426.9 .0039 410.5 0c-16.38 .0039-32.78 6.25-45.27 18.75l-49.97 49.9l-25.33-25.33c-18.69-18.72-49.19-18.72-67.88 0L116.7 148.7c-6.25 6.25-6.25 16.38 0 22.62c6.246 6.246 16.37 6.254 22.62 0l105.4-105.4c6.25-6.25 16.38-6.25 22.62 0l25.34 25.34L94.01 290c-52.5 52.5-85.61 121.4-93.86 195.2C-1.48 499.5 9.906 512 24.03 512c.875 0 1.733-.0103 2.608-.1353c73.87-8.25 142.8-41.24 195.3-93.86l271.3-271.2C518.2 121.8 518.2 81.24 493.3 56.25zM199.2 395.4c-44.46 44.57-102.8 73.88-166 83.34c9.193-62.62 38.58-121.3 83.42-166.1l198.6-198.7l82.74 82.74L199.2 395.4zM470.6 124.1L420.7 174.1l-82.75-82.75l49.93-49.93c12.5-12.5 32.74-12.52 45.26-.002l37.51 37.51C483.1 91.39 483.1 111.6 470.6 124.1z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPenClip = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;


//////////////////
// WEBPACK FOOTER
// ./~/@fortawesome/pro-light-svg-icons/faPenClip.js
// module id = jese
// module chunks = 0